var _slicedToArray = require("/Users/andrejgoncarenko/WebstormProjects/knackly/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/slicedToArray");
var _classCallCheck = require("/Users/andrejgoncarenko/WebstormProjects/knackly/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");
var IndirectVirtual = /*#__PURE__*/function () {
  "use strict";

  function IndirectVirtual(props, scope) {
    var contentType = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    _classCallCheck(this, IndirectVirtual);
    for (var _i = 0, _Object$entries = Object.entries(props); _i < _Object$entries.length; _i++) {
      var _Object$entries$_i = _slicedToArray(_Object$entries[_i], 2),
        key = _Object$entries$_i[0],
        value = _Object$entries$_i[1];
      this[key] = value;
    }
    this.scope = scope;
    // contentType is inherited from props (if it's there) or it can be explicitly specified
    // contentType should be 'text', 'markdown', or 'docx' (for indirects using opendocx)
    if (contentType || !('contentType' in this)) {
      this.contentType = contentType;
    }
  }

  // toString () {} // When an indirect is encountered during (synchronous) text-based assembly,
  //                // toString() is called on the instance in order to retrieve the text.
  //                // In (async) docx-based assembly, encountering an indirect causes a special
  //                // placeholder to be inserted so the resulting files can be composed later.
  return IndirectVirtual;
}();
module.exports = IndirectVirtual;